import api from '../utils/api'

export const createReverse = async (requestId) => {
    try {

        const token = localStorage.getItem('token');

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.post(`/reverses/create/${requestId}`).then((response) => {
            return response.data
        })

        return data

    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;
    }
}

export const getReverses = async (filter) =>{
    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(filter ? `/reverses${filter}`:`/reverses`).then((response) => {
            return response.data
        })

        return data


    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;
    }
}

export const getMyReverses = async (filter, currentPage, itemsPerPage, isReport) => {
    const limitDefault = itemsPerPage || 10; // quantidade por página padrão

    try {
        const token = localStorage.getItem('token');

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/reverses/team';

        if (filter) {
            if (isReport)
                url += `${filter}&isreport=true`;
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
        } else {
            if (isReport)
                url += `?isreport=true`;
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;
    }
}

export const getMyTeamReverses = async (filter, currentPage, itemsPerPage, isReport) => {
    const limitDefault = itemsPerPage || 10; // quantidade por página padrão

    try {
        const token = localStorage.getItem('token');

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/reverses/team';

        if (filter) {
            if (isReport)
                url += `${filter}&isreport=true`;
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
        } else {
            if (isReport)
                url += `?isreport=true`;
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;
    }
}

export const getReverseById = async (reverseId) =>{
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/reverses/${reverseId}`).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;     
    }
}

const ReverseService = {
    createReverse,
    getReverses,
    getMyReverses,
    getReverseById,
    getMyTeamReverses,
  };
  
  export default ReverseService;